import { TooltipDesktop, TooltipMobile } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './FeatureLabels.css';

interface ILabel {
  icon: React.ReactNode;
  title: string;
}

export interface IFeatureLabelsProps {
  labels: ILabel[];
  deviceType?: 'desktop' | 'mobile';
}

export const FeatureLabels: React.VFC<IFeatureLabelsProps> = ({ labels, deviceType = 'desktop' }) => {
  const TooltipComponent = deviceType === 'desktop' ? TooltipDesktop : TooltipMobile;

  return (
    <div className={styles['labels']}>
      {labels.map(({ title, icon }, index) => (
        <TooltipComponent key={index} title={title}>
          <div className={styles['label']}>{icon}</div>
        </TooltipComponent>
      ))}
    </div>
  );
};
